<template>
  <o-table :title="$t('core.approvers')" url="/api/system/user_approval_roles?include=user" ref="tableList" :custom-row-button="true">
    <template slot="filter">
      <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
        <o-filter-select :items="userList" :title="$t('core.user')" column="user_id" value-field="id" text-field="name"></o-filter-select>
        <o-filter-select :items="approvalRoles" :title="$t('core.approval_role')" column="approval_role" value-field="value" text-field="text"></o-filter-select>
        <o-filter-select :items="approvalRoleTypes" :title="$t('core.approval_role_type')" column="approval_role_type" value-field="value" text-field="text"></o-filter-select>
      </o-filter>
    </template>
    <template slot="head">
      <o-table-header column="user_id">{{$t('core.user')}}</o-table-header>
      <o-table-header column="approval_role">{{$t('core.approval_role')}}</o-table-header>
      <o-table-header column="approval_role_type">{{$t('core.approval_role_type')}}</o-table-header>
      <o-table-header column="region_id">{{$t('core.region')}}</o-table-header>
      <o-table-header column="is_deputy">{{$t('core.is_deputy')}}</o-table-header>
    </template>
    <template slot="body" slot-scope="props">
      <td>{{ props.item.user && props.item.user.data ? props.item.user.data.name + ' (' + props.item.user.data.email + ')' : '-' }}</td>
      <td>{{ props.item.approval_role || '-' }}</td>
      <td>{{ props.item.approval_role_type || '-' }}</td>
      <td>{{ getRegionName(props.item.region_id) || '-' }}</td>
      <td>
        <span class="badge" :class="props.item.is_deputy ? 'badge-success': 'badge-secondary'">
          {{ props.item.is_deputy ? $t('core.yes') : $t('core.no') }}
        </span>
      </td>
    </template>
    <template slot="body-controls" slot-scope="props">
      <td class="text-right">
        <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
          <o-delete method="delete" :url="$refs.tableList.deleteUrl() + '/' + props.item.id" v-on:action-executed="$refs.tableList.search"></o-delete>
          <router-link :to="{ path: $route.path + '/' + props.item.id }" class="btn btn-primary">
            <fa icon="pencil-alt"/>
          </router-link>
        </div>
      </td>
    </template>
  </o-table>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    userList: [],
    approvalRoles: [],
    approvalRoleTypes: [],
    regions: []
  }),
  mounted() {
    // Fetch users for the filter
    axios.get('/api/system/users?filter%5Bactive%5D=1%25&sortBy=name&per_page=99999').then((response) => {
      this.userList = response.data.data
    }).catch((error) => {
      console.error(error)
    })

    // Fetch regions for display
    axios.get('/api/system/regions?sortBy=region&per_page=99999').then((response) => {
      this.regions = response.data.data
    }).catch((error) => {
      console.error(error)
    })

    // Fetch enum values from the database
    axios.get('/api/system/user_approval_roles/enum-values').then((response) => {
      this.approvalRoles = response.data.approval_roles
      this.approvalRoleTypes = response.data.approval_role_types
    }).catch((error) => {
      console.error(error)
    })
  },
  methods: {
    getRegionName(regionId) {
      if (!regionId) return null
      const region = this.regions.find(r => r.id === regionId)
      return region ? region.region : null
    }
  }
}
</script>

